import { render, staticRenderFns } from "./OrdenListApprove.vue?vue&type=template&id=7d09d4da&scoped=true&"
import script from "./OrdenListApprove.vue?vue&type=script&lang=js&"
export * from "./OrdenListApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d09d4da",
  null
  
)

export default component.exports